import { Flex } from '@mantine/core';
import classes from './../../app.module.css';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

export const LoadingElement = ({
  icon,
  padding = '0px',
  flexGrow = 0,
  done = false,
  scale = 1,
}: {
  icon?: false | React.ReactNode;
  padding?: string;
  flexGrow?: number;
  done?: boolean;
  scale?: number;
}) => {
  return (
    <Flex
      direction={'column'}
      justify={'center'}
      style={{ padding: `calc(${padding} + 50px)`, flexGrow: flexGrow }}
    >
      <Flex
        direction={'row'}
        justify={'center'}
        style={{ width: '100%', position: 'relative' }}
      >
        <div
          className={done ? classes.loaderDone : classes.loader}
          style={{
            position: 'absolute',
            left: `calc(50% - 50px)`,
            top: `calc(50% - 50px)`,
            scale: scale,
          }}
        />
        {icon !== false && icon === undefined ? (
          done ? (
            <CheckOutlinedIcon
              sx={{ fontSize: 30 * scale }}
              className={classes.loaderDoneIcon}
            />
          ) : (
            <HourglassEmptyIcon sx={{ fontSize: 30 * scale }} />
          )
        ) : (
          icon
        )}
      </Flex>
    </Flex>
  );
};
